export const config = {
  createPunterUri: "https://betapi.hollywoodbets.net:443/createpunter",
  resetPunterPasswordUri:
    "https://betapi.hollywoodbets.net:443/api/punters/resetpassword",
  registrationListApiUri: "https://betapi.hollywoodbets.net/api/lists/",
  punterApiUri: "https://betapi.hollywoodbets.net:443/api/punters",
  serverUri: "https://winningform-api.hollywoodbets.net",
  //serverUri: 'http://localhost:4000',
  //reportingURL: "https://winningformreportingapi.hollywoodbets.net",
  reportingURL: "https://winningformreportingapi.hollywoodbets.net",
  //reportingURL: 'https://localhost:7238',
  authorityServer: "https://id.hollywoodbets.net/",
  strapiURL:
    "https://content-cms-api.hollywoodbets.net/api/v1/carousel-promotions?platform=winning-form-south-africa-en-za",
  // strapiURL:
  // "https://content-cms-api-uat.betsolutions.net/api/v1/carousel-promotions?platform=winning-form-south-africa-en-za",
};

export const trackLogoId = {
  showRaceCourseLogoTitleIds: [2, 6, 7, 8, 10, 11], // Add track asset ID here to pick up logo change
};
